import { Table } from "../../features/Table";
import { type Urgewald, urgewalds_columns } from "./columns";
import { FilterUrgewald } from "./filter";
import { useLocation } from "react-router-dom";

const client = "instit-quantilia";
const table_name = "urgewalds";

export const UrgewaldsTable = () => {
  const location = useLocation();
  const baseUrl = location.pathname;

  return (
    <Table<Urgewald, Urgewald>
      label="Urgewalds"
      client={client}
      table_name={table_name}
      columns={urgewalds_columns}
      disable_translations_request={true}
      filter={<FilterUrgewald />}
      actions={[
        {
          label: "actions.new",
          route: `${baseUrl}/new`,
        },
      ]}
    />
  );
};
